import { FooterAction } from './FooterAction';

export { FooterAction };
